export function getWindow() {
  return typeof window !== "undefined" ? window : null;
}
